import React from 'react';
import {
    Avatar, Button,
    Div, Input,
    List, ModalPage, ModalPageHeader, ModalRoot, PanelHeaderButton, SplitCol, SplitLayout
} from '@vkontakte/vkui';
import {
    Icon16ListBulletOutline, Icon24BrowserBack, Icon24InfoCircleOutline,
    Icon24PicturePlusOutline,
    Icon24Search
} from "@vkontakte/icons";
import {AdaptivityContext, formatQnt, getGUID} from "../assets/constants";
import Fancybox from "../assets/fancybox";
import {Icon24ListCheckOutline} from '@vkontakte/icons';
import {Icon20BrokenHeartOutline} from '@vkontakte/icons';
import KBInput from "../assets/KBInput";
import * as constants from "../assets/constants";
import IncomingDocsViewer from "./IncomingDocsViewer";
import ParamsList from "../catalog/ParamsList";
import BaseComponent from "../components/BaseComponent";

class IncomingProducts extends BaseComponent {

    state = {
        items_values: {},
        currentProduct: {},
        currentDoc: {},
    }

    interval = null
    setCurrentValue = (index, val) => {

        if (this.interval) {
            clearInterval(this.interval)
        }

        this.interval = setInterval(() => {
            clearInterval(this.interval)
            const olds = this.state.items_values
            const old = olds[index] ?? {}
            old.qnt = val
            olds[index] = old
            this.setState({items_values: olds})
        }, 770)
    }

    constructor(props) {
        super(props);

        this.GUID = getGUID()

        const data = localStorage.getItem(constants.values_incomings_key)

        if (data && data !== "undefined") {
            const items = JSON.parse(data)
            this.state.items_values = items
        }
    }


    saveValues = () => {
        localStorage.setItem(constants.values_incomings_key, JSON.stringify(this.state.items_values ? this.state.items_values : {}))
    }
    loadValues = () => {
        const data = localStorage.getItem(constants.values_incomings_key)

        if (data && data !== "undefined") {
            const items = JSON.parse(data)
            this.setState({items_values: items})

        }
    }


    componentWillUnmount = () => {
        super.componentWillUnmount()
        this.saveValues()

    }
    addDefectiveAct = (product, index) => {
        window.postMessage({type: "addDefectiveAct", product, index})
    }

    addQntInput = (product, index) => {
        const qnt = this.state.items_values ? (this.state.items_values[product.GUID]?.qnt ?? 0) : 0
        const series = this.state.items_values ? (this.state.items_values[product.GUID]?.series ?? []) : []
        product.realQnt = qnt
        product.series = series
        window.postMessage({type: "addQntInput", product, index})
    }

    receiveMessage = (event) => {
        if (event.data == 'incomingGoGetBack') {
            if (this.state.activeModal == null) {
                window.postMessage("stepPrev")
            } else {
                this.modalBack()
            }
        }
    }

    render() {

        const images_url = this.props.images_url
        const modals = (
            <ModalRoot activeModal={this.state.activeModal}>
                <ModalPage
                    id={constants.MODAL_PARAMS_LIST}
                    hideCloseButton={AdaptivityContext.isMobile}
                    onClose={this.modalBack}
                    settlingHeight={100}

                    header={
                        <ModalPageHeader className="sclads"
                                         before={<PanelHeaderButton
                                             onClick={this.modalBack}><Icon24BrowserBack/></PanelHeaderButton>}

                        >
                            Свойства товара {this.state.currentProduct.name}
                        </ModalPageHeader>
                    }
                >
                    <ParamsList
                        base_url={this.props.base_url}
                        product={this.state.currentProduct}
                        current_user={this.props.current_user}
                    />
                </ModalPage>

                <ModalPage
                    id={constants.MODAL_INCOMINGS_INFO}
                    hideCloseButton={AdaptivityContext.isMobile}
                    onClose={this.modalBack}
                    settlingHeight={100}

                    header={
                        <ModalPageHeader className="sclads"
                                         before={<PanelHeaderButton
                                             onClick={this.modalBack}><Icon24BrowserBack/></PanelHeaderButton>}

                        >
                            {this.state.currentProduct.name}
                        </ModalPageHeader>
                    }
                >
                    <IncomingDocsViewer items={this.state.currentDoc}/>
                </ModalPage>
            </ModalRoot>
        );

        return (
            <SplitLayout modal={modals}>
                <SplitCol>
                    <List className="incoming-products-list" style={{marginBottom: '70px'}}>
                        <Fancybox key={'IncomingProductsFancyBox' + this.GUID}>
                            {this.props.items.map((item, index) => {
                                    const name = item.name.toLowerCase()
                                    if (name.indexOf(this.props.search.toLowerCase().trim()) === -1) return;

                                    const qnt = this.state.items_values ? (this.state.items_values[item.GUID]?.qnt ?? 0) : 0

                                    const series = item.product_series ?? []

                                    let className = this.props.getColors ? 'success' : 'default'

                                    if (this.props.getColors) {
                                        if (item.quantity * 1 > qnt * 1) {
                                            className = 'error'
                                        }

                                        if (item.quantity * 1 < qnt * 1) {
                                            className = 'warning'
                                        }
                                    }

                                    return (
                                        <Div className={"incoming-products-row " + className}

                                             key={"incomingProductRow" + this.GUID + index}>
                                            <div className="incoming-products-row_name">
                                                <span
                                                    onClick={() => this.props.readonly ? '' : (
                                                        series.length > 0?
                                                        this.addQntInput(item, index):
                                                            window.postMessage({
                                                                timeout: 4000,
                                                                type: 'error',
                                                                text: 'У товара нет серий, введите количество поле ввода в этом списке'
                                                            })
                                                    )}>{item.name}</span>
                                                {!this.props.readonly &&

                                                    <Button before={<Icon20BrokenHeartOutline width={24}/>}
                                                            className="incoming-products-row_name_add-defective incoming-products-row_btn-info"
                                                            onClick={() => this.addDefectiveAct(item, index)}>
                                                        {AdaptivityContext.isMobile ? '' : 'Брак'}
                                                    </Button>
                                                }
                                            </div>
                                            <div
                                                className="incoming-products-row_qnt-need">{formatQnt(item.quantity * 1, true)}
                                                <span className="incoming-products-row_qnt-need_unit">{item.unit.title}</span>

                                            </div>
                                            {!this.props.hideInput &&
                                                <div className="incoming-products-row_qnt">
                                                <KBInput value={qnt ?? ''}
                                                         readonlyError={() => !this.props.readonly && window.postMessage({
                                                             timeout: 4000,
                                                             type: 'error',
                                                             text: 'У товара есть серии, нажмите на наименование товара для редактирования'
                                                         })}
                                                         onChange={(val) => this.setCurrentValue(item.GUID, val)}
                                                         readonly={this.props.readonly || series.length > 0} />

                                            </div>}
                                            <a data-fancybox={'gallery' + item.GUID}
                                               href={images_url + item.img.replace('https:/l', 'https://l').replace('https:/lab', 'https://lab').replace(images_url, '')}>
                                                {<Avatar mode="image" style={{borderRadius: '5%'}}
                                                         size={AdaptivityContext.isMobile ? 40 : 140}
                                                         src={images_url + 'image/200/200/' + item.img.replace('https:/l', 'https://l').replace('https:/lab', 'https://lab').replace(images_url, '')}
                                                />}
                                            </a>

                                            <div className="incoming-products-row_btns">
                                                <Button mode="secondary" size="s" onClick={() => this.showParms(index)}

                                                        className="btn-toolbar-sclads incoming-products-row_btn-info"
                                                ><Icon24ListCheckOutline width={18}/></Button>
                                                <Button mode="secondary" size="s" onClick={() => this.showDocs(index)}

                                                        className="btn-toolbar-sclads incoming-products-row_btn-info"
                                                ><Icon24InfoCircleOutline width={18}/></Button>

                                            </div>
                                        </Div>)
                                }
                            )}
                        </Fancybox>
                    </List>
                </SplitCol>
            </SplitLayout>
        )
    }

    showParms = (index) => {
        const item = this.props.items[index]
        item.id = item.product_id
        this.setState({currentProduct: item})
        this.setActiveModal(constants.MODAL_PARAMS_LIST)
    }
    showDocs = (index) => {
        const item = this.props.items[index]
        const doc = this.props.currentDocs[item.doc_id]

        const docs = {}

        docs[item.doc_id] = doc

        this.setState({currentDoc: docs, currentProduct: item})
        this.setActiveModal(constants.MODAL_INCOMINGS_INFO)
    }
}

export default IncomingProducts